import styled from "styled-components";
// import useIsMobile from '@/hooks/useIsMobile';
import { useTimeControlStore, useTimeStore } from "@graphic/stores";

function Time2D() {
  // const isMobile = useIsMobile();

  // const { time, handleCurrentSetTime } = useTimer();
  // const { play, speed, direction, setSpeed, togglePlay, setPlay, setDirection } = usePlay();
  const { play, speed, direction, setSpeed, setPlay, setDirection } =
    useTimeControlStore();
  const { time } = useTimeStore();

  const handleCurrentSetTime = () => {
    const { setCurrentTime } = useTimeStore.getState();
    setCurrentTime();
  };

  const speeds = [1, 5, 10, 50];

  return (
    <Container>
      <span
        style={{
          fontSize: "2rem",
          fontWeight: "bold",
          whiteSpace: "pre",
          lineHeight: "1.2rem"
        }}
      >
        {time.format("YYYY-MM-DD HH:mm:ss")} KST+0900
      </span>
    </Container>
  );
}
export default Time2D;

const Container = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 50;
  background-color: transparent;
  color: white;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 8px;
`;

const ButtonContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  gap: 12px;
  /* justify-content: flex-start; */

  justify-content: ${({ $isMobile }) => ($isMobile ? "center" : "flex-start")};
  align-items: center;
  padding: 18px;
`;

const ButtonText = styled.span`
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.02rem;
  color: #000;
`;
